import { useRef, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

interface IProps {
  children: React.ReactNode;
  location: never;
  history: any;
}

function usePrevious(value: any) {
  const prevLocationRef = useRef();
  useEffect(() => {
    prevLocationRef.current = value;
  });
  return prevLocationRef.current;
}
const ScrollToTop = (props: IProps) => {
  const prevLocation = usePrevious(props.location);
  useEffect(() => {
    // do comparison with previous and current id value
    if (prevLocation !== props.location && props.history.action === 'PUSH') {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [props.location, prevLocation, props.history.action]);

  return props.children;
};

export default withRouter(ScrollToTop as any);
